<section class="documents" aria-labelledby="documents-title">
  <h2 id="documents-title" class="documents__title">Documents</h2>

  <div class="documents__list">
    @if (!hasAnyDocuments()) {
      <div class="documents__message">
        Documents not available. Please check the shelter management system for
        records.
      </div>
    } @else {
      @if (hasMedicalRecords()) {
        <div class="documents__item">
          @if (normalizedMedicalRecordPdfUrl(); as medicalPdfUrl) {
            <a
              class="documents__link"
              [href]="medicalPdfUrl"
              target="_blank"
              rel="noopener noreferrer"
            >
              <lib-icon
                class="documents__download-icon"
                iconName="utilityDownloadIcon"
              />

              <span class="documents__name"> Medical Record Summary </span>
            </a>
          } @else {
            <button
              type="button"
              class="documents__link"
              (click)="generateMedicalRecordsPdf()"
            >
              <lib-icon
                class="documents__download-icon"
                iconName="utilityDownloadIcon"
              />

              <span class="documents__name"> Medical Record Summary </span>
            </button>
          }

          <span class="documents__file-type"> [PDF] </span>

          @if (medicalRecordsLastUpdated()) {
            <span class="documents__updated">
              Last updated
              {{ medicalRecordsLastUpdated() | date: "MM/dd/yyyy" }}
            </span>
          }
        </div>
      } @else {
        <div class="documents__message">
          Medical records not available. Please check the shelter management
          system for records.
        </div>
      }

      @if (hasVaccineRecords()) {
        <div class="documents__item">
          <button
            type="button"
            class="documents__link"
            (click)="generateVaccineRecordsPdf()"
          >
            <lib-icon
              class="documents__download-icon"
              iconName="utilityDownloadIcon"
            />

            <span class="documents__name"> Vaccine Records </span>
          </button>

          <span class="documents__file-type"> [PDF] </span>

          @if (vaccineRecordsLastUpdated()) {
            <span class="documents__updated">
              Last updated
              {{ vaccineRecordsLastUpdated() | date: "MM/dd/yyyy" }}
            </span>
          }
        </div>
      } @else {
        <div class="documents__message">
          Vaccine records not available. Please check the shelter management
          system for records.
        </div>
      }

      @if (normalizedAdoptionAgreementUrl(); as url) {
        <div class="documents__item">
          <a
            class="documents__link"
            [href]="url"
            target="_blank"
            rel="noopener noreferrer"
          >
            <lib-icon
              class="documents__download-icon"
              iconName="utilityDownloadIcon"
            />

            <span class="documents__name"> Adoption Agreement </span>
          </a>

          <span class="documents__file-type"> [PDF] </span>

          @if (adoptionAgreementLastUpdated()) {
            <span class="documents__updated">
              Last updated
              {{ adoptionAgreementLastUpdated() | date: "MM/dd/yyyy" }}
            </span>
          }
        </div>
      } @else {
        <div class="documents__message">
          Adoption contract not available. Please check the shelter management
          system for records.
        </div>
      }
    }
  </div>
</section>
